var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-holder"},[_c('div',{staticClass:"photo",on:{"click":function($event){_vm.pickPhoto()}}},[_c('img',{attrs:{"src":_vm.photoSrc,"alt":""}})]),_vm._v(" "),_c('input',{ref:"photoInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":function($event){_vm.setPhoto()}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2507cbdf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/PhotoUplaod.vue
// module id = null
// module chunks = 